import { BigNumber } from 'ethers'
import React from 'react'
import styled from 'styled-components'
import { ExchangeQuote } from '../../hooks'
import { formatCurrency } from '../../model'
import { BN_10_18 } from '../../utils'

const ONE_PERCENT = BN_10_18.div(100)

interface Props {
  quote: ExchangeQuote
  maxGasUsd: BigNumber
}

export function SavingsBar({ quote, maxGasUsd }: Props) {
  const { savingsUsd, costUsd, gasUsd } = quote.quote
  const total = savingsUsd.add(costUsd).add(maxGasUsd)

  const costPercent = getPercent(costUsd, total)
  const gasPercent = getPercent(gasUsd, total)
  const savingsPercent = getSavingsPercent(costPercent, gasPercent)

  return (
    <Container>
      <Savings percent={formatCurrency(16, savingsPercent)} />
      <Cost percent={formatCurrency(16, costPercent)} />
      <Gas percent={formatCurrency(16, gasPercent)} />
    </Container>
  )
}

function getPercent(numerator: BigNumber, denominator: BigNumber) {
  const percent = numerator.mul(BN_10_18).div(denominator)
  return percent.lt(ONE_PERCENT) ? ONE_PERCENT : percent
}

function getSavingsPercent(costPercent: BigNumber, gasPercent: BigNumber) {
  return BN_10_18.sub(costPercent).sub(gasPercent)
}

const Container = styled.div`
  display: flex;
`

interface PercentWidthProps {
  percent: string
}

export const Savings = styled.div.attrs((props: PercentWidthProps) => ({
  percent: props.percent,
}))`
  height: 5px;
  flex-basis: ${(props) => props.percent}%;
  background-color: #43d796;
  border-top: 1px solid #8efacb;
  border-bottom: 1px solid #8efacb;
`

export const Cost = styled.div.attrs((props: PercentWidthProps) => ({
  percent: props.percent,
}))`
  height: 5px;
  flex-basis: ${(props) => props.percent}%;
  background-color: #4b3657;
  border-top: 1px solid #824691;
  border-bottom: 1px solid #824691;
`

export const Gas = styled.div.attrs((props: PercentWidthProps) => ({
  percent: props.percent,
}))`
  height: 5px;
  flex-basis: ${(props) => props.percent}%;
  background-color: #504b3d;
  border-top: 1px solid #8d7b4f;
  border-bottom: 1px solid #8d7b4f;
`
